import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const SettingsApp = lazy(() => import('./SettingsApp'));
const AccountTab = lazy(() => import('./tabs/AccountTab'));
const CompanyTab = lazy(() => import('./tabs/CompanyTab'));
const SecurityTab = lazy(() => import('./tabs/SecurityTab'));
const PlanBillingTab = lazy(() => import('./tabs/PlanBillingTab'));
const NotificationsTab = lazy(() => import('./tabs/NotificationsTab'));
const AgentFormsTab = lazy(() => import('./tabs/AgentForms'));
const AgentFormsDetails = lazy(() => import('./tabs/AgentFormsDetails'));

const TeamTab = lazy(() => import('./tabs/TeamTab'));

/**
 * The Settings App Route.
 */
const SettingsAppRoute: FuseRouteItemType = {
	path: 'apps/settings',
	element: <SettingsApp />,
	children: [
		{
			path: 'account',
			element: <AccountTab />
		},
		{
			path: 'company',
			element: <CompanyTab />
		},
		{
			path: 'policyholders',
			element: <SecurityTab />
		},
		{
			path: 'plan-billing',
			element: <PlanBillingTab />
		},
		// {
		// 	path: 'security',
		// 	element: <SecurityTab />
		// },
		// {
		// 	path: 'agent-forms',
		// 	element: <AgentFormsTab />
		// },
		{
			path: 'notifications',
			element: <NotificationsTab />
		},
		{
			path: 'team',
			element: <TeamTab />
		},
		// {
		// 	path: 'agent-form/:formId',
		// 	element: <AgentFormsDetails />
		// },
		{
			path: '',
			element: <Navigate to="account" />
		}
	]
};

export default SettingsAppRoute;
